import MDBox from "../../../components/MDBox";
import DataTable from "../../../examples/Tables/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { getLanguageList } from "../../../actions/language";
import { useEffect, useState } from "react";

import CloseIcon from '@mui/icons-material/Close';

import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Icon,
  Paper,
  Stack,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  get as _get,
  map as _map,
  isEmpty as _isEmpty,
  find as _find,
} from "lodash";
import MDTypography from "../../../components/MDTypography";
import {
  addMiaInterestReq,
  deleteMiaInterestReq,
  getMiaInterestById,
  getMiaInterestList,
  updateStatusReq,
  updateInterestReq,
} from "../../../actions/miaInterest";
import MDButton from "../../../components/MDButton";
import { showError } from "../../../utils";
import { Field, FieldArray, Form, Formik } from "formik";
import toast from "react-hot-toast";
import { renderTextField } from "../../../inputFields/formFields";
import { styled } from "@mui/material/styles";
import IconButton from '@mui/material/IconButton';
import pxToRem from "../../../../src/assets/theme/functions/pxToRem";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const MiaInterest = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [newLabel, setNewLabel] = useState([]);
  const [newStartLabel, setNewStartLabel] = useState([]);
  const [newEndLabel, setNewEndLabel] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [isAddLanguage,setIsAddLanguage] = useState(false)

  useEffect(() => {
    dispatch(getLanguageList());
    dispatch(getMiaInterestList());
  }, [dispatch]);

  const storeProps = useSelector((state) => {
    return {
      data: _get(state, "miaInterest.list.records", []),
      languageList: _get(state, "language.list", []),
      ruleId: _get(state, "miaInterest.interestData._id", ""),
      label: _get(state, "miaInterest.interestData.label", []),
      startLabel: _get(state, "miaInterest.interestData.startLabel", []),
      endLabel: _get(state, "miaInterest.interestData.endLabel", []),
    };
  });
  console.log("mia props ::", storeProps);

  const initialValues = {
    label: [
      {
        local: "",
        name: "",
        languageName: "",
      },
    ],
    startLabel: [
      {
        local: "",
        name: "",
        languageName: "",
      },
    ],
    endLabel: [
      {
        local: "",
        name: "",
        languageName: "",
      },
    ],
  };

  const getTitleName = (label) =>
    _map(label, (lab) => ({ name: lab.name }))[0].name;

  const handleChangeStatus = (value, id) => {
    const statusData = { id, status: value };
    dispatch(updateStatusReq(statusData));
  };

  const tableData = {
    columns: [
      {
        Header: "Interest",
        accessor: "label",
        Cell: (row) => (
          <Tooltip title={getTitleName(_get(row, "row.original.label"))}>
            <MDTypography
              variant="caption" color="text" fontWeight="regular" fontSize="14px"
              textTransform="capitalize"
            >
              {getTitleName(_get(row, "row.original.label"))}
            </MDTypography>
          </Tooltip>
        ),
        // align: "left",
      },
      {
        Header: "Start Label",
        accessor: "sname",
        Cell: (row) => (
          <Tooltip title={getTitleName(_get(row, "row.original.startLabel"))}>
            <MDTypography
              variant="caption" color="text" fontWeight="regular" fontSize="14px"
              textTransform="capitalize"
            >
              {getTitleName(_get(row, "row.original.startLabel"))}
            </MDTypography>
          </Tooltip>
        ),
        // align: "left",
      },
      {
        Header: "End Label",
        accessor: "ename",
        Cell: (row) => (
          <Tooltip title={getTitleName(_get(row, "row.original.endLabel"))}>
            <MDTypography
              variant="caption" color="text" fontWeight="regular" fontSize="14px"
              textTransform="capitalize"
              // style={{
              //   overflow: "hidden",
              //   textOverflow: "ellipsis",
              //   width: "4rem",
              // }}
            >
              {getTitleName(_get(row, "row.original.endLabel"))}
            </MDTypography>
          </Tooltip>
        ),
        // align: "left",
      },
      {
        Header: "status",
        accessor: "status",
        Cell: (row) => (
          <Switch
            checked={_get(row, "row.original.status")}
            onChange={(e, value) =>
              handleChangeStatus(value, _get(row, "row.original._id"))
            }
          />
        ),
        align: "center",
      },
      {
        Header: "action",
        accessor: "action",
        Cell: (row) => (
          <MDBox width="100px">
            <IconButton sx={{ 
              color: "#54AF3A", 
              backgroundColor: "#E8FFE2", 
              borderRadius: "6px" ,
              width: pxToRem(35),
              height: pxToRem(35),
              '&:hover' :{
                backgroundColor: "#e6f3e2"
              }
            }}>
              <Icon
                fontSize="small"
                onClick={() => handleClickOpen(_get(row, "row.original._id"))}
                sx={{ cursor: "pointer" }}
              >
                edit_icon
              </Icon>
            </IconButton>
            <IconButton sx={{ 
              color: "#F05A22", 
              backgroundColor: "#fde4db", 
              borderRadius: "6px" ,
              width: pxToRem(35),
              height: pxToRem(35),
              cursor: "pointer", ml: 2,
              '&:hover' :{
                backgroundColor: "#fbcfbf"
              }
            }}>
              <Icon
                fontSize="small"
                onClick={() => {
                  setOpenConfirmation(true);
                  setDeleteId(_get(row, "row.original._id"));
                }}
                sx={{ cursor: "pointer" }}
              >
                delete
              </Icon>
            </IconButton>
          </MDBox>
        ),
        align: "center",
        width:"5%",
      },
    ],

    rows: _get(storeProps, "data", []),
  };

  const { columns, rows } = tableData;

  const handleClickOpen = (id) => {
    setOpen(true);
    dispatch(getMiaInterestById(id));
  };

  const handleClose = () => {
    setIsNew(false);
    setOpen(false);
    setNewLabel([]);
    setNewStartLabel([]);
    setNewEndLabel([]);
  };

  const addMiaInterest = () => {
    dispatch(getLanguageList());
    setIsNew(true);
    labelledData();
  };

  const labelledData = () => {
    _map(_get(storeProps, "languageList"), (langListObj) => {
      const obj = {
        local: langListObj.code,
        languageName: langListObj.label,
      };
      newLabel.push(obj);
      newStartLabel.push(obj);
      newEndLabel.push(obj);
    });
  };

  const saveMiaInterest = (values) => {
    values.isSlider = true;

  if (isNew) {
    dispatch(addMiaInterestReq(values));
  } else {
    console.warn("values from uodate",values);
    values.id = _get(storeProps, "ruleId");

    dispatch(updateInterestReq(values));
  }
   //dispatch(addMiaInterestReq(values));
    handleClose();
  };

  const handleChange = (event, value, index, setFieldValue, formValues) => {
    let checkFormLabel;
    if (!_isEmpty(formValues.label)) {
      checkFormLabel = _find(formValues.label, (e) => e.local === value.local);
    }
    if (!checkFormLabel) {
      setFieldValue(`label.${index}`, value);
      setFieldValue(`startLabel.${index}`, value);
      setFieldValue(`endLabel.${index}`, value);
    } else toast.error("Same Language Not Allowed!");
  };

  const disabledSaveBtn = (values) => {
    const labelName = _find(_get(values, "label", []), (val) =>
      _isEmpty(_get(val, "name", ""))
    );
    const startLabelName = _find(_get(values, "startLabel", []), (val) =>
      _isEmpty(_get(val, "name", ""))
    );
    const endLabelName = _find(_get(values, "endLabel", []), (val) =>
      _isEmpty(_get(val, "name", ""))
    );

    return (
      !_isEmpty(labelName) ||
      !_isEmpty(startLabelName) ||
      !_isEmpty(endLabelName)
    );
  };

  const handleConfirmationClose = () => {
    setOpenConfirmation(false);
    setDeleteId("");
  };

  const deleteMiaInterest = () => {
    dispatch(deleteMiaInterestReq({ id: deleteId }));
    handleConfirmationClose();
  };

  const getOptionList = () => {
    if (storeProps.label.length <= 2 && !isAddLanguage) {
      return storeProps.label
    } else if (isAddLanguage && storeProps.label.length < 2 && _isEmpty(newLabel)) {
      labelledData()
      return newLabel
    } else if (!_isEmpty(newLabel)) {
      return newLabel;
    } else {
      return storeProps.label
    }
}


  return (
    <MDBox>
      <MDBox display="flex" justifyContent="flex-end" textAlign="center" p={2} >
        
        <MDButton
          variant="outlined"
          color="orange"
          onClick={() => addMiaInterest()}
        >
          {" "}
          <Icon fontSize="small" sx={{ mt: -0.25 }}>
            add_icon
          </Icon>{" "}
          Add
        </MDButton>
      
      </MDBox>
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={true}
        noEndBorder
        //   canSearch
        forSettings
      />
      
      <Dialog
        open={open || isNew}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={{ m: 0, pr: 8 }}>
          {isNew ? "Add Interest" : "Edit Interest"}
          {handleClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 10,
              color: (theme) => theme.palette.grey[700],
              backgroundColor: (theme) => theme.palette.grey[200],
            }}
          >
            <CloseIcon />
          </IconButton>
      ) : null}
        </DialogTitle>
        <Divider sx={{ marginTop: "0", marginBottom: "0px" }} />
        <DialogContent sx={{ marginTop: 0 }}>
          <Formik
            initialValues={isNew ? initialValues : storeProps}
            // validationSchema={schema}
            enableReinitialize
            onSubmit={async (values) => saveMiaInterest(values)}
            render={({
              values,
              errors,
              touched,
              handleReset,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <Form noValidate onSubmit={handleSubmit}>
                  <FieldArray
                    name="label"
                    render={({ insert, remove, push }) => (
                      <>
                        <Stack
                          direction="column" spacing={2} py={3}
                          // divider={<Divider orientation="vertical" flexItem />}
                          // spacing={1}
                        >
                          {values.label.map((label, index) => (
                            <>
                              <MDBox width="100%">
                                {errors?.label?.[index]?.name &&
                                  // touched?.label?.[index]?.name &&
                                  showError(errors.label[index].name)}

                              {isNew &&
                                values.label.length <
                                  storeProps.languageList.length && (
                                  <MDBox textAlign="right">
                                    <MDButton
                                      p={3}
                                      size="small"
                                      variant="text"
                                      color="info"
                                      sx={{padding: "0px", fontSize: "14px", letterSpacing: "0.5px", fontWeight: "600"}}
                                      onClick={() => {
                                        isNew ?
                                        push({
                                          local: "",
                                          name: "",
                                          languageName: "",
                                        })
                                       :
                                        push({
                                          local: "",
                                          name: "",
                                          languageName: "",
                                        })
                                        setIsAddLanguage(true)
                                      }
                                    }
                                    >
                                     Add Language
                                    </MDButton>
                                  </MDBox>
                                )}

                                {values.label.length > 1 && (
                                  <MDBox textAlign="right">
                                    <MDButton
                                      variant="text"
                                      color="error"
                                      padding="0 !important"
                                      onClick={() => {
                                        remove(index);
                                        values.startLabel.splice(index);
                                        values.endLabel.splice(index);
                                      }}
                                      sx={{padding: "0px", fontSize: "14px", letterSpacing: "0.5px", fontWeight: "600"}}
                                    >
                                      Remove
                                    </MDButton>
                                  </MDBox>
                                )}
                                <Grid container spacing={1} p={0}>
                                <Grid item xs={12} md={12}>
                                <Field name={`label`}>
                                  {({ field }) => (
                                    <>
                                      <Autocomplete
                                        getOptionLabel={(option) =>
                                          option.languageName
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option.local === value.local
                                        }
                                        value={field.value[index]}
                                        onChange={(event, value) =>
                                          handleChange(
                                            event,
                                            value,
                                            index,
                                            setFieldValue,
                                            values
                                          )
                                        }
                                        options={
                                          isNew ? newLabel : getOptionList()
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Language"
                                          />
                                        )}
                                        disabled={(!isNew && !_isEmpty(label.languageName))}
                                      />
                                    </>
                                  )}
                                </Field>
                                {errors?.label?.[index]?.local &&
                                  // touched?.label?.[index]?.local &&
                                  showError(errors.label[index].local)}
                                </Grid>
                                <Grid item xs={12} md={12}>
                                <Field
                                  name={`label.${index}.name`}
                                  component={renderTextField}
                                  label="Interest Title"
                                  fullWidth
                                  margin="0"
                                  // disabled={appUserView}
                                />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                <Field
                                  name={`startLabel.${index}.name`}
                                  component={renderTextField}
                                  label="Start Interest Label"
                                  fullWidth
                                  // disabled={appUserView}
                                />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                <Field
                                  name={`endLabel.${index}.name`}
                                  component={renderTextField}
                                  label="End Interest Label"
                                  fullWidth
                                  // disabled={appUserView}
                                />
                                </Grid>
                                </Grid>
                                
                              </MDBox>
                            </>
                          ))}
                        </Stack>
                        <MDBox
                          pt={2}
                          display="flex"
                          justifyContent={
                            isNew &&
                            values.label.length < storeProps.languageList.length
                              ? "flex-end"
                              : "flex-end"
                          }
                        >
                          
                          <MDBox>
                            <MDButton
                              variant="outlined"
                              color="success"
                              type="submit"
                              disabled={disabledSaveBtn(values)}
                              sx={{ marginRight: "15px" }}
                            >
                              Save
                            </MDButton>
                            <MDButton
                              variant="outlined"
                              color="error"
                              onClick={handleClose}
                            >
                              Cancel
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </>
                    )}
                  />
                </Form>
              );
            }}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openConfirmation} onClose={handleConfirmationClose} fullWidth maxWidth="sm" >
        <DialogTitle textAlign="center" sx={{ m: 0, px: 4 , pt:4}}>
          {"Are you sure you want to delete Mia Interest?"}
          
        </DialogTitle>
        <DialogActions justifyContent="center" textAlign="center" display="flex" sx={{ justifyContent:"center", pb:4 }}>
          <MDButton variant="outlined" color="success" onClick={deleteMiaInterest} sx={{mr:1, minWidth:"125px"}}>
            Agree
          </MDButton>
          <MDButton
            variant="outlined"
            color="error"
            onClick={handleConfirmationClose}
            sx={{minWidth:"125px"}}
          >
            Disagree
          </MDButton>
          
        </DialogActions>
      </Dialog>
    </MDBox>
  );
};

export default MiaInterest;
